import{jsx as t}from"react/jsx-runtime";import{Helmet as r}from"react-helmet-async";const i=({title:e})=>t(r,{children:t("title",{children:e})});export{i as MetaDataTitle};
